import type { GameTheme, GameThemeId } from "@skillscratch/shared-types";
import { paydayBonanza } from "./payday-bonanza/paydayBonanza";
import { theMoneyMint } from "./the-money-mint/theMoneyMint";
import { millionaireMaker } from "./millionaire-maker/millionaireMaker";
import { crazy99s } from "./crazy-99s/crazy99s";
import { tripleCashBlast } from "./triple-cash-blast/tripleCashBlast";
import { goldCard } from "./gold-card/goldCard";
import { blizzardBucks } from "./blizzard-bucks/blizzardBucks";
import { canyonCash } from "./canyon-cash/canyonCash";
import { cliffCash } from "./coral-cash/coralCash";
import { duneDollars } from "./dune-dollars/duneDollars";
import { fortuneField } from "./fortune-field/fortuneField";
import { jungleJackpot } from "./jungle-jackpot/jungleJackpot";
import { mountainMillions } from "./mountain-millions/mountainMillions";
import { riverRiches } from "./river-riches/riverRiches";
import { skyCard } from "./sky-card/skyCard";
import { goldCardSkillScratch } from "./gold-card-skillscratch/goldCardSkillScratch";


export const gameThemes = {
  [paydayBonanza.id]: paydayBonanza,
  "the-money-mint": theMoneyMint,
  "millionaire-maker": millionaireMaker,
  "crazy-99s": crazy99s,
  "triple-cash-blast": tripleCashBlast,
  // "gold-card": goldCard,
  "gold-card-15": goldCard(15),
  "gold-card-30": goldCard(30),
  "gold-card-60": goldCard(60),
  "gold-card-150": goldCard(150),
  [blizzardBucks.id]: blizzardBucks,
  [canyonCash.id]: canyonCash,
  [cliffCash.id]: cliffCash,
  [duneDollars.id]: duneDollars,
  "dune-dollar": duneDollars,
  [fortuneField.id]: fortuneField,
  [jungleJackpot.id]: jungleJackpot,
  [mountainMillions.id]: mountainMillions,
  [riverRiches.id]: riverRiches,
  [skyCard.id]: skyCard,
  [goldCardSkillScratch.id]: goldCardSkillScratch,
} satisfies Record<GameThemeId, GameTheme>;

export function hasGameTheme(themeId: string): themeId is GameThemeId {
  return themeId in gameThemes;
}
